class CheckinSettingsController {
  /* @ngInject */
  constructor($log, MerchantConfigurationService, NewTokenService) {
    const that = this;
    this.isSuperAdmin = StorageService.getLocalStorage('superAdmin');
    that.loading = {
      settings: false
    };

    that.settings = {
      checkin: {
        enabled: false
      },
      tables: {
        enabled: false
      }
    };

    const loadSettings = () => {
      if (that.loading.settings) return;
      that.loading.settings = true;
      MerchantConfigurationService.getCheckinConfiguration().then((settings) => {
        that.settings = settings;
      }, (reason) => {
        $log.error('CheckinSettingsController', 'loadSettings', reason);
      }).finally(() => {
        that.loading.settings = false;
      });
    };

    const init = () => {
      loadSettings();
    };

    that.$onInit = init;

    that.save = () => {
      if (that.loading.settings) return;
      that.loading.settings = true;
      MerchantConfigurationService.setCheckinConfiguration(that.settings).then(loadSettings, (reason) => {
        $log.error('CheckinSettingsController', 'save', reason);
      }).finally(() => {
        that.loading.settings = false;
      });
    };

    that.reset = loadSettings;
  }
}

export default CheckinSettingsController;



/** WEBPACK FOOTER **
 ** ./client/app/components/checkin/settings/settings.controller.js
 **/